export const ADDONS_MENU_TOGGLE = 'at/addons/ADDONS_MENU_TOGGLE'
export const ADDONS_MENU_CLOSE = 'at/addons/ADDONS_MENU_CLOSE'



// WEBPACK FOOTER //
// ./web/js/support/addons/actionTypes.js